/** Decorative inline illustration for the login brand panel: globe, graduation cap and a flight path — no external image assets required. */
export const LoginIllustration = () => (
  <svg viewBox="0 0 400 320" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
    <circle cx="200" cy="170" r="120" fill="rgba(255,255,255,0.08)" />
    <circle cx="200" cy="170" r="90" stroke="rgba(255,255,255,0.25)" strokeWidth="1.5" />
    <circle cx="200" cy="170" r="90" stroke="rgba(255,255,255,0.15)" strokeDasharray="4 6" strokeWidth="1" />
    <ellipse cx="200" cy="170" rx="90" ry="34" stroke="rgba(255,255,255,0.25)" strokeWidth="1.2" />
    <ellipse cx="200" cy="170" rx="90" ry="34" stroke="rgba(255,255,255,0.25)" strokeWidth="1.2" transform="rotate(60 200 170)" />
    <ellipse cx="200" cy="170" rx="90" ry="34" stroke="rgba(255,255,255,0.25)" strokeWidth="1.2" transform="rotate(120 200 170)" />

    {/* flight path */}
    <path
      d="M60 230 C 120 120, 260 90, 340 60"
      stroke="rgba(255,255,255,0.55)"
      strokeWidth="2"
      strokeDasharray="6 8"
      fill="none"
    />
    <g transform="translate(332, 48) rotate(35)">
      <path d="M0 8 L20 0 L4 16 L6 24 L0 20 L-6 24 L-4 16 L-20 0 Z" fill="#ffffff" opacity="0.9" />
    </g>

    {/* graduation cap */}
    <g transform="translate(140, 150)">
      <path d="M60 0 L120 22 L60 44 L0 22 Z" fill="#ffffff" />
      <path d="M30 30 L30 55 C30 63 90 63 90 55 L90 30 L60 40 Z" fill="rgba(255,255,255,0.85)" />
      <line x1="118" y1="22" x2="118" y2="52" stroke="#ffffff" strokeWidth="2" />
      <circle cx="118" cy="56" r="4" fill="#ffffff" />
    </g>

    {/* base ellipse shadow */}
    <ellipse cx="200" cy="268" rx="70" ry="10" fill="rgba(0,0,0,0.12)" />
  </svg>
);
